import {
  ChangeDetectorRef,
  Component,
  OnInit,
  Input,
  SimpleChanges,
  OnChanges,
  Output,
  EventEmitter,
} from '@angular/core';
import { FormArray, FormBuilder, FormControl } from '@angular/forms';
import { FormGroup } from '@angular/forms';

@Component({
    selector: 'app-tree-select',
    templateUrl: './app-tree-select.component.html',
    styleUrls: ['./app-tree-select.component.scss'],
    standalone: false
})
export class AppTreeSelectComponent implements OnChanges, OnInit {

  @Input() subs: Object[];
  @Input() counterTree: any;
  @Input() nestedValues: [];
  @Input() itemSelected: number;
  @Input() indexSelected: number;
  @Input() parentForm: Object;
  @Input() controlId: number;
  @Input() controlLevel: number;
  @Input() required: boolean;
  @Input() labeltext: boolean;
  @Input() fieldSelected: any;
  /** Opt-in: autocomplete en Provincia/Distrito. Chile 2 niveles permanece en select nativo. */
  @Input() searchable = false;
  @Output() selectChange: EventEmitter<any> = new EventEmitter();

  public selectedId = -1;
  defForm: FormGroup;
  fields = []
  nextName: string
  setChanges: boolean = false
  searchText = '';
  filteredOptions: any[] = [];
  showOptions = false;
  selectedOptionIndex = -1;

  constructor(
    private formBuilder: FormBuilder,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {

    if (this.nestedValues && this.counterTree && Array.isArray(this.counterTree)) {
      this.nestedValues.forEach((element, index) => {
        if (this.counterTree[index] && this.counterTree[index].id == this.controlId) {
          this.subs = element;
        }
      });
    }

    this.defForm = <FormGroup>this.parentForm;

    this.fnSetFieldSelected()

  }

  //#region Asignar Valores si tiene seleccionados
  fnSetFieldSelected() {
    if (this.fieldSelected) {
      this.setChanges = true;
      this.ngOnChanges(null)
    }
  }

  private type14FormArray(): FormArray | null {
    if (!this.defForm || this.controlId == null) {
      return null;
    }
    return (
      this.defForm.controls[this.controlId]
      ?? this.defForm.controls[String(this.controlId)]
    ) as FormArray;
  }

  setFieldToForm() {
    const customField = this.type14FormArray();
    const formgroup = customField?.controls?.[0] as FormGroup;
    const subForm = formgroup?.get('sub') as FormArray;
    if (!subForm) {
      return;
    }
    const level = Number(this.controlLevel);

    if (this.fieldSelected?.length) {
      for (const element of this.fieldSelected.filter((e) => e.nivel > 1)) {
        const subIndex = element.nivel - 2;
        const controlName = 'seleccion' + (element.nivel - 1);
        while (subForm.length <= subIndex) {
          subForm.push(this.formBuilder.group({ [controlName]: [''] }));
        }
      }
    }

    this.fieldSelected.forEach((element) => {
      if (element.nivel > 1 && element.nivel - 1 === level) {
        const subIndex = element.nivel - 2;
        const controlName = 'seleccion' + (element.nivel - 1);
        const row = subForm.at(subIndex) as FormGroup;
        if (row?.contains(controlName)) {
          row.get(controlName).setValue(String(element.seleccion), { emitEvent: false });
          this.nextName = element.nameSub;
          this.showChilds(element.seleccion);
          this.syncSearchTextFromForm();
        } else {
          this.setChanges = true;
        }
      }
    });

    this.fieldSelected.forEach((element) => {
      if (element.nivel - 1 === level && this.setChanges) {
        this.setChanges = false;
        this.ngOnChanges(null);
      }
    });
  }
  //#endregion


  //#region Agregar Control
  addControl(sub) {
    const customField = this.type14FormArray();
    const subArr = customField?.controls?.[0]?.['controls']?.['sub'] as FormArray;
    if (
      subArr
      && this.formGroupLength == Number(this.controlLevel) - 1
      && sub['sub'] !== undefined
    ) {
      subArr.push(this.formBuilder.group(this.createFormControl(this.fields)));
    }

    if (this.fieldSelected) {
      this.setFieldToForm();
    }
  }

  //#endregion


  ngOnChanges(changes: SimpleChanges) {
    this.createFields();
    this.itemSelected = +this.itemSelected;

    if (changes?.itemSelected && !changes.itemSelected.firstChange) {
      this.selectedId = -1;
      this.resetSearchUi();
    }

    if (this.itemSelected && this.defForm && this.subs && Array.isArray(this.subs)) {
      const arrLen = this.type14FormArray()?.controls?.length ?? 0;
      this.subs.map(sub => {
        if (+sub['id'] === +this.itemSelected && Number(this.controlLevel) > (arrLen - 1)) {
          // this.labeltext = sub["name"]
          this.labeltext = sub["nameSub"]
          this.addControl(sub);
        }
      });
    }

    this.syncSearchTextFromForm();
  }

  //#region Crear Form Controls
  createFormControl(fields: string[]) {
    const control: Record<string, FormControl> = {};
    fields.forEach((x, index) => {
      if (this.controlLevel === index + 1) {
        control[x] = new FormControl('');
      }
    });
    return control;
  }
  //#endregion

  //#region Crear Nombre de FormControl
  createFields() {

    for (let i = 0; i < this.controlLevel; i++) {
      let defaultName = "seleccion" + (i + 1)
      const found = this.fields.find(element => element == defaultName);
      if (!found) {
        this.fields.push(defaultName)
      }
    }

  }
  //#endregion

  getChilds(op) {
    return op['sub'] || [];
  }

  showChilds(id) {
    const numId = +id;
    this.selectedId = numId;
    if (numId > 0) {
      this.ensureSubLevelForSelection(numId);
    }
  }

  nextLevel() {

    return +this.controlLevel + 1;
  }

  showChildsTest(value) {
    this.showChilds(value);
    this.selectChange.emit(value);
    this.cdr.detectChanges();
  }

  /**
   * Al elegir región (u otro nivel con hijos), crea sub[n].seleccionN+1 de inmediato.
   * En nivel 1, subs son países: la región está en subs[itemSelected].sub.
   */
  private ensureSubLevelForSelection(selectedId: number): void {
    if (!selectedId || !this.subs?.length || !this.defForm) {
      return;
    }
    let match = this.subs.find((s: { id?: number }) => +s.id === selectedId) as
      | { id?: number; nameSub?: string; sub?: unknown[] }
      | undefined;
    if (!match && this.itemSelected) {
      const parentNode = this.subs.find((s: { id?: number }) => +s.id === +this.itemSelected) as
        | { sub?: Array<{ id?: number; nameSub?: string; sub?: unknown[] }> }
        | undefined;
      if (parentNode?.sub?.length) {
        match = parentNode.sub.find((s) => +s.id === selectedId);
      }
    }
    if (!match || match['sub'] === undefined) {
      return;
    }
    const subForm = this.getSubFormArray();
    if (!subForm) {
      return;
    }
    const nextControlName = 'seleccion' + (this.controlLevel + 1);
    const nextSubIndex = this.controlLevel;
    if (subForm.length <= nextSubIndex) {
      subForm.push(this.formBuilder.group({ [nextControlName]: [''] }));
    } else {
      const row = subForm.at(nextSubIndex) as FormGroup;
      if (row && !row.contains(nextControlName)) {
        row.addControl(nextControlName, new FormControl(''));
      }
    }
    if (match['nameSub']) {
      this.nextName = match['nameSub'];
    }
  }

  get formGroupLength() {
    const customField = this.type14FormArray();
    return customField?.controls?.[0]?.['controls']?.['sub']?.controls?.length ?? 0;
  }

  private getSubFormArray(): FormArray | null {
    try {
      const customField = this.type14FormArray();
      const formgroup = customField?.controls?.[0] as FormGroup;
      return formgroup?.get('sub') as FormArray;
    } catch {
      return null;
    }
  }

  /** Solo enlazar si addControl ya creó el FormGroup con ese control (evita error sub -> n -> seleccion2). */
  hasSubControlAt(index: number, controlName: string): boolean {
    const sub = this.getSubFormArray();
    const row = sub?.at(index) as FormGroup;
    return !!row?.contains(controlName);
  }

  onSearchInput(event: Event, options: any[]): void {
    const input = event.target as HTMLInputElement;
    this.searchText = input?.value ?? '';
    this.applySearchFilter(options);
    if (!this.searchText.trim()) {
      this.clearCurrentSelection();
      return;
    }
    const currentId = this.getCurrentControlValue();
    const current = (options || []).find((option) => String(option?.id) === String(currentId));
    if (current && String(current.name) !== this.searchText) {
      this.clearCurrentSelection();
    }
  }

  onSearchFocus(options: any[]): void {
    this.filteredOptions = [...(options || [])];
    this.showOptions = this.filteredOptions.length > 0;
    this.selectedOptionIndex = -1;
  }

  onSearchBlur(): void {
    setTimeout(() => {
      this.showOptions = false;
      this.selectedOptionIndex = -1;
      // Si escribió el nombre exacto sin clic, confirma el id (si no, el select queda required inválido).
      this.commitExactSearchMatch();
    }, 200);
  }

  private commitExactSearchMatch(): void {
    if (!this.searchable) {
      return;
    }
    const term = this.searchText.trim().toLowerCase();
    if (!term) {
      return;
    }
    if (this.getCurrentControlValue()) {
      return;
    }
    const matches = (this.getCurrentLevelOptions() || []).filter(
      (option) => String(option?.name ?? '').toLowerCase() === term
    );
    if (matches.length !== 1) {
      return;
    }
    const fieldName = 'seleccion' + Number(this.controlLevel);
    this.selectSearchOption(matches[0], fieldName);
  }

  onSearchOptionMouseDown(event: Event, option: { id?: number; name?: string }, fieldName: string): void {
    event.preventDefault();
    this.selectSearchOption(option, fieldName);
  }

  private selectSearchOption(option: { id?: number; name?: string }, fieldName: string): void {
    if (option?.id == null) {
      return;
    }
    const sub = this.getSubFormArray();
    const row = sub?.at(this.controlLevel - 1) as FormGroup;
    row?.get(fieldName)?.setValue(String(option.id));
    this.searchText = option.name != null ? String(option.name) : '';
    this.showOptions = false;
    this.selectedOptionIndex = -1;
    this.showChildsTest(option.id);
  }

  private applySearchFilter(options: any[]): void {
    const term = this.searchText.toLowerCase().trim();
    const list = options || [];
    this.filteredOptions = term
      ? list.filter((option) => String(option?.name ?? '').toLowerCase().includes(term))
      : [...list];
    this.showOptions = this.filteredOptions.length > 0;
    this.selectedOptionIndex = -1;
  }

  private clearCurrentSelection(): void {
    const fieldName = 'seleccion' + this.controlLevel;
    const sub = this.getSubFormArray();
    const row = sub?.at(this.controlLevel - 1) as FormGroup;
    if (row?.contains(fieldName) && row.get(fieldName).value) {
      row.get(fieldName).setValue('');
    }
    this.selectedId = -1;
    this.selectChange.emit('');
  }

  private resetSearchUi(): void {
    this.searchText = '';
    this.filteredOptions = [];
    this.showOptions = false;
    this.selectedOptionIndex = -1;
  }

  private syncSearchTextFromForm(): void {
    if (!this.searchable) {
      return;
    }
    const options = this.getCurrentLevelOptions();
    const currentId = this.getCurrentControlValue();
    const match = options.find((option) => String(option?.id) === String(currentId));
    this.searchText = match?.name != null ? String(match.name) : '';
  }

  private getCurrentLevelOptions(): any[] {
    if (!this.subs || !this.itemSelected) {
      return [];
    }
    const parent = (this.subs as any[]).find((node) => +node?.id === +this.itemSelected);
    return parent?.sub || [];
  }

  private getCurrentControlValue(): string {
    const fieldName = 'seleccion' + this.controlLevel;
    const sub = this.getSubFormArray();
    const row = sub?.at(this.controlLevel - 1) as FormGroup;
    return row?.get(fieldName)?.value ?? '';
  }

}
